import { Component } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { BaseFieldComponent } from '../base-field.component';
import { ButtonRadioGroupComponent, ButtonRadioOption } from '../../../../../components/button-radio-group/button-radio-group.component';

@Component({
    selector: 'app-checkbox-field',
    imports: [IonicModule, ButtonRadioGroupComponent],
    template: `
        <ion-item lines="none">
            <ion-label>{{ field.label }}</ion-label>
        </ion-item>
        <div class="checkbox-field-buttons">
            <app-button-radio-group
                [options]="checkboxOptions"
                [value]="value"
                [disabled]="readonly"
                (valueChange)="onValueChange($event)"
            ></app-button-radio-group>
        </div>
        @if (field.helpText) {
            <ion-note class="field-help">{{ field.helpText }}</ion-note>
        }
    `,
    styles: [`
        .checkbox-field-buttons {
            padding: 0 16px 8px;
        }
        .field-help {
            padding: 4px 16px;
            font-size: 12px;
        }
    `]
})
export class CheckboxFieldComponent extends BaseFieldComponent {
    readonly checkboxOptions: ButtonRadioOption[] = [
        {
            value: true,
            label: 'Zoals ontworpen',
            icon: 'checkmark',
            selectedIconColor: 'success'
        },
        {
            value: false,
            label: 'Afwijkend gedrag',
            icon: 'close',
            selectedIconColor: 'danger'
        }
    ];

    initialize(value: any): void {
        // Handle string "true"/"false" from API
        if (typeof value === 'string') {
            this.value = value === 'true';
        } else if (value === null || value === undefined) {
            // null/undefined means no selection yet
            this.value = null;
        } else {
            this.value = value;
        }
    }

    serialize(): any {
        return this.value;
    }

    onValueChange(checked: boolean): void {
        this.value = checked;
        this.emitChange(checked);
    }
}
